import { createSlice } from '@reduxjs/toolkit';
import { IImagerQuotaDTO } from 'business/models/Models';
import { cloneDeep } from 'lodash';
import { getAllImagerQuota, saveImagerQuota } from 'redux/thunks/imagerQuota';
import { showSnackBar } from 'utils/Global';

export type ImagerQuotaState = {
  imagerQuotaList: IImagerQuotaDTO[];
  imagerQuotaOriginalList: IImagerQuotaDTO[];
  isDirty: boolean;
};

const initialState = {
  imagerQuotaList: [],
  imagerQuotaOriginalList: [],
  isDirty: false,
} as ImagerQuotaState;

const imagerQuotaReducer = createSlice({
  name: 'ImagerQuota',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getAllImagerQuota.pending, (state, action) => {});
    builder.addCase(getAllImagerQuota.fulfilled, (state, action) => {
      state.imagerQuotaList = action.payload;
      state.imagerQuotaOriginalList = cloneDeep(action.payload);
    });
    builder.addCase(saveImagerQuota.pending, (state, action) => {});
    builder.addCase(saveImagerQuota.fulfilled, (state, action) => {
      state.imagerQuotaOriginalList = cloneDeep([...state.imagerQuotaList]);
      state.isDirty = false;
      showSnackBar('Imager Quota saved.');
    });
  },
  reducers: {
    setImagerQuotaList: (state, action) => {
      state.imagerQuotaList = action.payload;
    },
    setImagerQuotaOriginalList: (state, action) => {
      state.imagerQuotaOriginalList = action.payload;
      state.isDirty = false;
    },
    setImagerQuotaIsDirty: (state, action) => {
      state.isDirty = action.payload;
    },
    setImagerGroupPlateQuota: (state, action) => {
      for (const quota of state.imagerQuotaList) {
        if (quota.id === action.payload.selectedQuotaId) {
          quota.imagerGroups = action.payload.imagerGroups;
          quota.isDirty = true;
          state.isDirty = true;
          break;
        }
      }
    },
  },
});

export const {
  setImagerQuotaList,
  setImagerQuotaOriginalList,
  setImagerQuotaIsDirty,
  setImagerGroupPlateQuota,
} = imagerQuotaReducer.actions;

export default imagerQuotaReducer.reducer;
